import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchParserResult } from '@nimbus-library/features/graph/models/search-parser-result.model';
import { protectedResources } from '../auth-config';
import { GraphPresence } from '../models/presence.model';
import { Profile } from '../models/profile';

// noinspection JSUnusedGlobalSymbols
export enum CommonUserSearchOptions {
  DisplayName = 'displayName',
  GivenName = 'givenName',
  Surname = 'surname',
  Mail = 'mail',
  UserPrincipalName = 'userPrincipalName',
}

export enum ExtendedUserSearchOptions {
  jobTitle = 'jobTitle',
  businessPhones = 'businessPhones',
  mobilePhone = 'mobilePhone',
}

@Injectable({
  providedIn: 'root',
})
export class GraphApiService {
  public constructor(private http: HttpClient) {}

  public getMe(): Observable<Profile> {
    return this.http.get(protectedResources.graphApiMe.endpoint);
  }

  public getMyProfileIcon(): Observable<Blob> {
    return this.http.get(protectedResources.graphApiMyAvatar.endpoint, {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
    });
  }

  public getMyPresence(): Observable<GraphPresence> {
    return this.http.get(protectedResources.graphApiMyPresence.endpoint);
  }

  public getUserIdentities(userId: string): Observable<object> {
    return this.http.get(`${protectedResources.graphApiUsers.endpoint}/${userId}/identities`);
  }

  public getContacts(searchInput: SearchParserResult, includeServices: boolean): Observable<object> {
    const contactRequestBatchSize = 20;
    return this.http.get(
      this.composeContactsRequest(`${protectedResources.graphApiUsers.endpoint}`, searchInput, contactRequestBatchSize, includeServices),
      {
        headers: new HttpHeaders({ ConsistencyLevel: 'eventual' }),
      },
    );
  }

  private composeContactsRequest(url: string, searchExpression: SearchParserResult, pageSize: number, includeServices: boolean): string {
    return `${url}?$top=${pageSize}&${this.getSearch(searchExpression)}${
      !includeServices ? '&$filter=(accountEnabled eq true)' : ''
    }&$orderBy=displayName ASC`;
  }

  private getSearch(searchExpression: SearchParserResult): string {
    return `$search=${this.composeSearch(searchExpression.plainSearchText)}`;
  }
  private composeSearch(searchText: string): string {
    const commonFilters: string[] = [];
    if (searchText && searchText !== '') {
      commonFilters.push(
        ...Object.keys(CommonUserSearchOptions).map((key) => `"${key}:${this.doubleEncodeValue(searchText.toLocaleLowerCase())}"`),
      );

      commonFilters.push(
        ...Object.keys(ExtendedUserSearchOptions).map((key) => `"${key}:${this.doubleEncodeValue(searchText.toLocaleLowerCase())}"`),
      );
    }

    return commonFilters.join(' OR ');
  }

  private doubleEncodeValue(value: string): string {
    value = value.replace(new RegExp(/"/g), '\\"');
    return encodeURIComponent(encodeURIComponent(value));
  }
}
